import { FC, PropsWithChildren } from 'react';

import { setDrawerOpen } from 'store/drawerSlice';
import { setFocusOnExtent } from 'store/mapSlice';

import { useAppDispatch } from 'hooks/defaultStoreHooks';

import { activeSource } from 'components/map/Layers';
import { TextButton } from 'components/sharedElements/sharedElements';

import { isMobile } from 'utilities/isMobile';

export const CenterActiveSourceGeometryButton: FC<PropsWithChildren> = () => {
  const dispatch = useAppDispatch();

  return (
    <TextButton
      onClick={() => {
        const dispatchSetFocusOnExtent = () => {
          dispatch(
            setFocusOnExtent({
              type: 'fit',
              extent: activeSource.getExtent(),
              duration: 250,
              zoomLevel: 12.3
            })
          );
        };

        if (isMobile()) {
          dispatch(setDrawerOpen('minimized'));
          setTimeout(() => dispatchSetFocusOnExtent(), 250);
        } else {
          dispatchSetFocusOnExtent();
        }
      }}
      icon="raa-icon-gps"
    >
      Centrera
    </TextButton>
  );
};
